import { useState, useEffect, useRef } from 'react'

import Reveal from 'reveal.js'

import styles from 'styles/CharacterStylesScreen.module.css'
import { characterStylesAssets } from 'assets/images/CharacterStylesScreen'
import leftArrow from 'assets/images/common/leftArrowSecondary.svg'
import rightArrow from 'assets/images/common/rightArrowSecondary.svg'

import { sendSocketMessage } from 'config/socket/socketUtil'



type CharacterStylesScreenPropsType = {
  selectedAvatar: string;
  firebaseRef: any;
  socketInstance: any;
}

type ActivityType = {
  imgSrc: string
  avatarStyle: string
  avatar: string
}


function CharacterStylesScreen({ selectedAvatar, firebaseRef, socketInstance }: CharacterStylesScreenPropsType) {

  const slideNumberRef = useRef<number>(0)
  const assetRef = useRef<ActivityType[]>()

  const [ currentSlide, setCurrentSlide ] = useState<number>(0)

  const [ assets, setAssets ] = useState<ActivityType[]>(characterStylesAssets)

  useEffect(() => {
    // socket.on('message', ({ className :lecture, id, message}: { className: string; id: string, message: any}) => {
    //   if( lecture === className && id === studentId && message.screen === "characterStylesScreen") {
    //    if(message.navigateTo === 'left') {
    //     navigateLeft()
    //    } else if(message.navigateTo === 'right') {
    //     navigateRight()
    //    }
    //   }
    // })

    const callbackFunction = (state: any) => {
      if(state.navigateTo === 'left') {
        navigateLeft()
      } else if(state.navigateTo === 'right') {
        navigateRight()
      }
    }
    socketInstance.onMessage('characterStylesScreen', callbackFunction)
  },[])


  useEffect(()=>{
    const res = [...characterStylesAssets.filter((asset=>asset.avatar === selectedAvatar))]
    assetRef.current = res;
    setAssets(res);
    slideNumberRef.current = 0
    setCurrentSlide(0)
    firebaseRef.update({ selectedAvatarStyle: assetRef.current[1].avatarStyle })
  },[selectedAvatar]);


  const goLeft = () => {
    navigateLeft()
    sendSocketMessage({ state: { navigateTo: 'left' }, action: 'characterStylesScreen'})
    // socket.emit('message', {className: className, id: studentId, message: { screen: 'characterStylesScreen', navigateTo: 'left' }})
  }

  const goRight = () => {
    navigateRight()
    sendSocketMessage({ state: { navigateTo: 'right' }, action: 'characterStylesScreen'})
    // socket.emit('message', {className: className, id: studentId, message: { screen: 'characterStylesScreen', navigateTo: 'right' }})
  }

  const navigateLeft = () => {
    let newArray = assetRef.current;
    if(newArray){
      newArray.push(newArray.shift()!)
      firebaseRef.update({ selectedAvatarStyle: newArray[1].avatarStyle })
      setAssets([...newArray])
      slideNumberRef.current = slideNumberRef.current - 1
      setCurrentSlide(slideNumberRef.current)
    }  
  }

  const navigateRight = () => {
    let newArray = assetRef.current;
    if(newArray){
      newArray.unshift(newArray.pop()!)
      firebaseRef.update({ selectedAvatarStyle: newArray[1].avatarStyle })
      setAssets([...newArray])
      slideNumberRef.current = slideNumberRef.current + 1
      setCurrentSlide(slideNumberRef.current)
    }
  }

  const onSelectCharacterStyle = () => {
    if(assetRef.current){
      firebaseRef.update({ selectedAvatarStyle: assetRef.current[1].avatarStyle })
    }
      Reveal.next();
  }


  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        Select a Style
      </div>
      <div className={styles.slideContainer}>
        <img
          src={leftArrow}
          alt='left arrow'
          className={currentSlide === 0 ? styles.hiddenBtn : styles.image}
          onClick={goLeft}
        />
        <div className={styles.slides}>
          {assets.map((asset, i) => {
            return (
                <img
                  key={`CharacterStylesScreen${asset?.avatarStyle}`}
                  src={asset?.imgSrc}
                  className={i === assets.length - 1 ? styles.slideImages : styles.hidden}
                />
            )
          })}
        </div>
        <img
          src={rightArrow}
          alt='right arrow'
          className={currentSlide === assets.length - 1 ? styles.hiddenBtn : styles.image}
          onClick={goRight}
        />
      </div>
      <div className={styles.button} onClick={onSelectCharacterStyle}>
        SELECT
      </div>
    </div>
  )
}

export default CharacterStylesScreen
